const Colors = {
  error: "#ff3333",
  error50: "#FEF3F2",
  error600: "#D92D20",
  error700: "#B91C1C",
  gray: "#F8FAFC",
  brand50: "#EDF8FF",
  brand700: "#0066FF",
  brand950: "#0E2B5D",
  black: "#242424",
  blackText: "#334155",
  gray50: "#F9FAFB",
  gray200: "#E2E8F0",
  gray300: "#CBD5E1",
  gray400: "#94A3B8",
  gray500: "#64748B",
  gray600: "#475467",
  white: "#FFF",
  blueLogin: "#96BFF2",
} as const;

export default Colors;
